import styled from 'styled-components';

const UserNameRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 14px;
  gap: 2px;
`;

export default UserNameRow;
